import axios, { AxiosPromise } from 'axios';

import { ICommodityState } from '../../../@types/model/masterData/commodityState/commodityState';
import { ICommodityStateUpsert } from '../../../@types/model/masterData/commodityState/commodityStateUpsert';

export default class CommodityStateHttpService {
    public static getCommodityStateData() : AxiosPromise<Array<ICommodityState>> {
        return axios.get(`${API_URL}/v1/CommodityState/GetAllWeb`);
    }

    public static addOrUpdateCommodityState(upsert : ICommodityStateUpsert) : AxiosPromise<ICommodityState> {
        return axios.post(`${API_URL}/v1/CommodityState/PostCommodityState`, upsert);
    }

    public static deleteCommodityState(commodityStateId : number) : AxiosPromise<ICommodityState> {
        return axios.delete(`${API_URL}/v1/CommodityState/Delete`, {
            params : { commodityStateId },
        });
    }
}
